import React from "react";
import TopHeader from "./TopHeader";
import HeaderBanner from "./HeaderBanner";

const Header = () => {

    return (
        <React.Fragment>
            <div className="dnw_header">
                <div className="dnw_header_l">
                    <div className="dnw_header_r">
                        <TopHeader/>
                        <HeaderBanner/>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
};

export default Header
